import { Region, RegionProvider, useRegion } from './RegionProvider'

export function makeSupportedRegionProvider<SupportedRegion extends Region>(
  supportedRegions: readonly SupportedRegion[]
) {
  function SupportedRegionProvider({ region, children }: { region: SupportedRegion; children: React.ReactNode }) {
    return <RegionProvider region={region} children={children} />
  }

  function useSupportedRegion(): SupportedRegion {
    const region = useRegion()

    if (!supportedRegions.includes(region as SupportedRegion)) {
      throw Error(
        `An unsupported region was found when trying to use useSupportedRegion. ${region} is not one of the supported regions: ${supportedRegions.join(
          ', '
        )}`
      )
    }

    // It is safe to typecast this because we know that:
    // - the type of `supportedRegions` is `SupportedRegion[]`
    // - above, we made sure that `region` was in supportedRegions
    // Since we know that `region` is in `supportedRegions`, and we know that `supportedRegions` is type `SupportedRegion[]`, then
    // we also know that `region` has type `SupportedRegion`
    return region as SupportedRegion
  }

  return {
    SupportedRegionProvider,
    useSupportedRegion,
  }
}
